export enum SurveyStep {
	Basics = 1,
	Define = 2,
	LogicAndLayout = 3,
	Distribution = 4,
	Reporting = 5,
	Confirm = 6,
	Complete = 7,
	Admin = 8, // This is not a step that can be saved
	DefineQuestions = 9,
	ManageDimensions = 10,
	BrandingAndTheme = 11,
}
